import { useQuery, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchPublisherData } from "../api/publisherService";
export var publisherQueryKey = function (id) { return ["publisher", id]; };
export var usePublisherQuery = function (id) {
    var ky = useOkapiKy();
    return useQuery(publisherQueryKey(id), function () { return fetchPublisherData(id, ky); }, { enabled: !!id });
};
/**
 * Single cache strategy for publisher mutations: refetch the detail from the
 * server instead of writing the mutation response into the cache, so the
 * detail never diverges from what the backend actually stored.
 */
export var useInvalidatePublisher = function () {
    var queryClient = useQueryClient();
    return function (id) {
        return Promise.all([
            queryClient.invalidateQueries(publisherQueryKey(id)),
            queryClient.invalidateQueries("publishers"),
        ]);
    };
};
